/**
 * Closes the modal.
 */
const closeMenu = (
  focusedElementBeforeMenu: HTMLElement|null,
  mobileMenu: HTMLElement,
  menuOverlay: HTMLElement,
  menuToggle: HTMLElement
) => {
	mobileMenu.classList.add( 'is-closed' )
	menuToggle.setAttribute( 'aria-expanded', 'false' )
	mobileMenu.setAttribute( 'aria-hidden', 'true' )
	setTimeout( () => mobileMenu.setAttribute( 'data-menu-closed', 'true' ), 50 )
	if ( focusedElementBeforeMenu ) focusedElementBeforeMenu.focus()
}

export default closeMenu
